import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import SearchQuerySummary from './searchQuerySummary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'reactstrap';
import { Translate } from 'react-localize-redux';
import classnames from 'classnames';

class SearchResultRibbon extends Component {
    state = { collapse: true };

    render() {
        const fd = this.props.searchParams;
        if (isNullOrUndefined(fd))
            return '';

        return (
            <div className={classnames('sr-ribbon is-sticky', { 'tinted': this.props.tinted })} style={{ top: this.props.user.authentication.limitedUser ? '0px' : null, right: this.props.right }}>
                { !this.props.isMobile && <div>
                    <div className='desktop-hidden param-opener' onClick={() => this.setState({ collapse: !this.state.collapse })}>
                        <span style={{ fontWeight: 'bold' }}><Translate id='Search.Parameters'></Translate> </span>
                        <FontAwesomeIcon icon={!this.state.collapse ? "angle-up" : "angle-down"} className='svg-standard-color' />
                    </div>
                </div> }
                <div className="main-header">
                    <span><Translate id="Search.Common.SubjectSearch"/></span>
                </div>
                { !this.props.isMobile && <Collapse isOpen={!this.state.collapse} className='desktop-always-expanded'>
                    <SearchQuerySummary />
                </Collapse> }
            </div>
        );
    }

}

export default connect(state => ({ ...state.search, user: state.userContext }))(SearchResultRibbon);